import React from "react";
import PropTypes from "prop-types";
import { reduxForm, Field, change } from "redux-form";
import find from "lodash/find";
import styled from "styled-components";
import { TextField, SelectField } from "redux-form-material-ui";
import { Toolbar, GET_LIST } from "admin-on-rest";
import MenuItem from "material-ui/MenuItem";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { RestClient } from "../../restClient";
// import { Values } from 'redux-form-website-template';

const parse = value => (value === undefined ? 0 : parseInt(value, 10)); //10 for decimal radix params

class TransferCreateForm extends React.Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => this.props.save(values, redirect));

  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      dataItems: [],
      bank: "",
      bank_account: "",
      balance: "0"
    };
    this.loadMarketer();
  }

  loadMarketer = () => {
    let url = "marketers";
    const options = {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "created_at", order: "DESC" }
    };
    RestClient(GET_LIST, url, options)
      .then(items => {
        this.setState({
          dataItems: items.data
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  onOptionChange = (event, value) => {
    let data = find(this.state.dataItems, { id: value });
    this.setState({
      bank: data && data.custom1 && data.custom1.bank ? data.custom1.bank : "",
      bank_account:
        data && data.custom1 && data.custom1.account
          ? data.custom1.account
          : "",
      balance: data && data.custom2 ? data.custom2.balance : "0"
    });
  };

  render() {
    const { invalid, submitOnEnter, toolbar, translate } = this.props;
    return (
      <div>
        <form className="simple-form">
          <div className="container-form">
            <div>
              <Field
                name="user_id"
                component={SelectField}
                onChange={this.onOptionChange}
                label="resources.marketers.transfers.fields.marketer"
                floatingLabelText="Marketer"
              >
                {this.state.dataItems.map((option, j) => (
                  <MenuItem
                    value={option.id}
                    primaryText={`${option.first_name} ${option.last_name}`}
                    key={`option-${j}`}
                  />
                ))}
              </Field>
            </div>
            <Container>
              <Box>
                {translate("resources.marketers.transfers.fields.bank")}
              </Box>
              <Box>{this.state.bank} </Box>
            </Container>
            <Container>
              <Box>
                {translate("resources.marketers.transfers.fields.bank_account")}
              </Box>
              <Box>{this.state.bank_account} </Box>
            </Container>
            <Container>
              <Box>
                {translate("resources.marketers.transfers.fields.balance")}
              </Box>
              <Box>{this.state.balance} </Box>
            </Container>
            <div>
              <Field
                parse={parse}
                name="amount"
                component={TextField}
                label="resources.marketers.transfers.fields.amount"
                floatingLabelText="Amount"
              />
            </div>
          </div>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}

const Box = styled.div`
  display: flex;
  flex: 1;
`;
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding-top: 16px;
  color: rgb(120, 129, 149);
  font-size: 16px;
  line-height: 24px;
  width: 256px;
  justify-content: flex-start;
  font-family: Roboto, sans-serif;
`;

TransferCreateForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func
};

TransferCreateForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const form = "record-form";
const fields = ["amount", "user_id"];
const enhance = compose(
  connect(
    (state, props) => {
      let initialValues = {};
      return { initialValues };
    },
    dispatch => {
      return {
        // This will be passed as a property to the presentational component
        changeFieldValue: function(field, value) {
          dispatch(change(form, field, value));
        }
      };
    }
  ),
  reduxForm({
    form,
    fields,
    enableReinitialize: true
  })
);

export default enhance(TransferCreateForm);



// WEBPACK FOOTER //
// ./src/marketers/transfers/TransferCreateForm.js